import React from 'react';
import { Card, CardProps } from '@mui/material';

export interface GlassCardProps extends CardProps {
  blur?: number;
  opacity?: number;
  borderOpacity?: number;
  highlightColor?: string;
}

export const GlassCard: React.FC<GlassCardProps> = ({
  children,
  blur = 16,
  opacity = 0.88,
  borderOpacity = 0.75,
  highlightColor,
  sx,
  ...props
}) => {
  return (
    <Card
      {...props}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '16px',
        background: `rgba(255, 255, 255, ${opacity})`,
        backdropFilter: `blur(${blur}px)`,
        WebkitBackdropFilter: `blur(${blur}px)`,
        border: `1px solid rgba(226, 232, 240, ${borderOpacity})`,
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.06)',
        transition: 'box-shadow 0.25s ease, transform 0.25s ease',
        ...(highlightColor && {
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            background: highlightColor,
          },
        }),
        ...sx,
      }}
    >
      {children}
    </Card>
  );
};

export default GlassCard;
